import type { FC, ReactElement } from 'react';

import type { GameV1 } from '@/api/games';
import { GameErrorNotAuthDesktop } from '@/modules/game/GameError/components/GameErrorNotAuth/components/GameErrorNotAuthDesktop';
import { GameErrorNotAuthMobile } from '@/modules/game/GameError/components/GameErrorNotAuth/components/GameErrorNotAuthMobile';

type TDeviceType = 'desktop' | 'mobile';

interface IGameErrorNotAuthPayload {
  game: GameV1;
  isDemoAvailable: boolean;
}

interface IGameErrorNotAuthProps extends IGameErrorNotAuthPayload {
  isMobile: boolean;
}

const notAuthRenderers: Record<
  TDeviceType,
  (payload: IGameErrorNotAuthPayload) => ReactElement
> = {
  desktop: () => <GameErrorNotAuthDesktop />,
  mobile: ({ game, isDemoAvailable }) => (
    <GameErrorNotAuthMobile game={game} isDemoAvailable={isDemoAvailable} />
  ),
};

export const GameErrorNotAuth: FC<IGameErrorNotAuthProps> = ({
  game,
  isDemoAvailable,
  isMobile,
}) => {
  const deviceType: TDeviceType = isMobile ? 'mobile' : 'desktop';

  return notAuthRenderers[deviceType]({ game, isDemoAvailable });
};
